"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quote = void 0;
const class_validator_1 = require("class-validator");
class Quote {
    constructor(props) {
        Object.assign(this, props);
    }
    // TODO: When the payload attribute is removed
    // we need to set forbidNonWhitelisted: true
    validate(validatorOptions) {
        return (0, class_validator_1.validateSync)(this, Object.assign(Object.assign({}, validatorOptions), { whitelist: false }));
    }
}
exports.Quote = Quote;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)({ groups: ['UPDATE', 'READ'] }),
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], Quote.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)({ groups: ['READ', 'UPDATE'] }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Object)
], Quote.prototype, "organisation", void 0);
__decorate([
    (0, class_validator_1.IsOptional)({ groups: ['UPDATE', 'READ'] }),
    __metadata("design:type", Object)
], Quote.prototype, "payload", void 0);
//# sourceMappingURL=Quote.js.map